import styled from 'styled-components';
import { Link } from 'ui/links';
import { link2 } from 'ui/theme';
import { Cell } from './Cell';

type CampaignCellProps = {
  campaign: string;
  id: number;
  rowIndex: number;
};

export const CAMPAIGN_DATA_TEST = 'campaigns-campaign-name';
const COLUMN_ID = 'campaign';

const StyledCampaignCell = styled(Cell)`
  ${link2};
`;

export const CampaignCell = ({ campaign, id, rowIndex }: CampaignCellProps) => {
  const campaignLink = `/analytics/campaignPerformance?campaignId=${id}`;

  return (
    <StyledCampaignCell data-test={CAMPAIGN_DATA_TEST} columnId={COLUMN_ID} $rowIndex={rowIndex}>
      <Link href={campaignLink}>{campaign}</Link>
    </StyledCampaignCell>
  );
};
